import { render, staticRenderFns } from "./InstructionModal.vue?vue&type=template&id=6137ca5a&scoped=true&"
import script from "./InstructionModal.vue?vue&type=script&lang=js&"
export * from "./InstructionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137ca5a",
  null
  
)

export default component.exports